import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, getIn } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from 'common/components/farm/locations/risks/sub-risks/sub-risk-collapsible-section';
import { ActionButton } from 'core/components/action-button';
import deleteIcon from 'core/assets/svg/delete-icon.svg';
import addIcon from 'core/assets/svg/ic-add.svg';
import useStyles from '../liability-coverages-styles';

const FIELD_NAME = 'farmLiabilityCoverage.domesticEmployees';
const MAX_EMPLOYEES = 2;

const DomesticEmployees = ({ disabled = false, onChangeActive }) => {
  const classes = useStyles();
  const { values, setFieldValue } = useFormikContext();

  const items = getIn(values, FIELD_NAME) || [];

  const handleAdd = () => {
    setFieldValue(FIELD_NAME, [...items, { id: uuidv4(), firstName: '', lastName: '' }]);
    onChangeActive();
  };

  return (
    <div className={classes.sectionContainer}>
      <SubRiskCollapsibleSection
        type="secondary"
        content={<div className={classes.headerText}>Domestic employee(s)</div>}
        initialOpen={items.length > 0}
      >
        {items.map((item, index) => (
          <Grid container key={item.id} alignItems="center">
            <Grid item xs={11}>
              <Grid container spacing={2}>
                <Field
                  xs={6}
                  type="string"
                  id={`${FIELD_NAME}[${index}].firstName`}
                  name={`${FIELD_NAME}[${index}].firstName`}
                  mode="dark"
                  label="First name"
                  disabled={disabled}
                />
                <Field
                  xs={6}
                  type="string"
                  id={`${FIELD_NAME}[${index}].lastName`}
                  name={`${FIELD_NAME}[${index}].lastName`}
                  mode="dark"
                  label="Last name"
                  disabled={disabled}
                />
              </Grid>
            </Grid>
            <Grid item xs={1}>
              <ActionButton
                onClick={() => {
                  const newItems = items.filter((_, i) => i !== index);
                  setFieldValue(FIELD_NAME, newItems);
                  onChangeActive();
                }}
                className={classes.deleteInsuredButton}
                icon={deleteIcon}
                disabled={disabled}
                size="small"
              />
            </Grid>
          </Grid>
        ))}
        {items.length < MAX_EMPLOYEES && (
          <Grid container>
            <Button
              className={classes.addAnotherButton}
              disabled={disabled}
              onClick={handleAdd}
              startIcon={<img src={addIcon} alt="add" width={28} height={28} />}
            >
              Add a domestic employee
            </Button>
          </Grid>
        )}
      </SubRiskCollapsibleSection>
    </div>
  );
};

DomesticEmployees.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChangeActive: PropTypes.func.isRequired
};

export default DomesticEmployees;
